import React from 'react';
import { Formik, Form } from 'formik';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { RiCloseLine } from 'react-icons/ri';
import { makeStyles } from '@mui/styles';
import { FormattedMessage } from 'react-intl';

type Props<T> = {
  isOpen: boolean;
  onClose: () => void;
  onSave: (values: T) => void;
  size?: 'md' | 'xs' | 'sm' | 'lg' | 'xl';
  header?: string;
  children: JSX.Element | JSX.Element[];
  initialValues?: Partial<T>;
  cancelBtnIntlId?: string;
  confirmBtnIntlId?: string;
};

const useStyles = makeStyles({
  closeIcon: {
    cursor: 'pointer',
    fontSize: '32px',
    color: 'rgba(0, 0, 0, 0.33)',
  },
  actions: {
    paddingBottom: '0',
  },
});

export const FormDialog = <T,>({
  isOpen,
  onClose,
  onSave,
  size = 'md',
  header,
  children,
  initialValues = {},
  cancelBtnIntlId = 'cancel',
  confirmBtnIntlId = 'confirm',
}: Props<T>): JSX.Element => {
  const classes = useStyles();

  return (
    <Dialog fullWidth open={isOpen} onClose={onClose} maxWidth={size}>
      <DialogTitle>
        <div>{header}</div>
        <RiCloseLine className={classes.closeIcon} onClick={() => onClose()} />
      </DialogTitle>
      <DialogContent>
        <Formik onSubmit={onSave} initialValues={initialValues as T}>
          <Form>
            {React.Children.map(children, (item) => item)}
            <DialogActions className={classes.actions}>
              <Button
                size="small"
                variant="contained"
                color="secondary"
                onClick={onClose}
              >
                <FormattedMessage id={cancelBtnIntlId} />
              </Button>
              <Button
                size="small"
                variant="contained"
                color="primary"
                type="submit"
              >
                <FormattedMessage id={confirmBtnIntlId} />
              </Button>
            </DialogActions>
          </Form>
        </Formik>
      </DialogContent>
    </Dialog>
  );
};
